

interface LoadingOverlayProps {
  message?: string;
  progress?: number;
  primaryColor?: string;
}

export const LoadingOverlay = ({ message = 'Loading...', progress, primaryColor = '#007bff' }: LoadingOverlayProps) => {
  return (
    <div class="visualizer-loading-overlay" style={{ '--primary-color': primaryColor }}>
      <div class="visualizer-loading-spinner" />
      <div class="visualizer-loading-text">{message}</div>
      {progress !== undefined && (
        <div class="visualizer-loading-progress">
          <div
            class="visualizer-loading-progress-bar"
            style={{ width: `${progress * 100}%` }}
          />
        </div>
      )}
    </div>
  );
};
